import { Text, TextProps } from '@wegroup/design-system';
import React, { forwardRef } from 'react';

interface Props {
  children: unknown;
  size?: 'sm' | 'md';
}

// Tooltip requires a ref to be passed for it to work
const TooltipCircle = forwardRef<
  HTMLParagraphElement,
  Props & Omit<TextProps, 'size'>
>(({ children, size = 'md', ...props }, ref) => {
  const chakraSize = {
    md: '6',
    sm: '18px',
  }[size];

  return (
    <Text
      display="flex"
      justifyContent="center"
      alignItems="center"
      border="1px solid"
      borderColor="text.gray"
      borderRadius="full"
      color="text.gray"
      w={chakraSize}
      h={chakraSize}
      // Used to negate very small offset for text
      pl="1px"
      py="0.5"
      cursor="pointer"
      _hover={{ color: 'gray.600', borderColor: 'gray.600' }}
      textAlign="center"
      flexShrink={0}
      textStyle={size === 'sm' ? 'smallBody' : 'normalBody'}
      ref={ref}
      {...props}
    >
      {children}
    </Text>
  );
});

export default TooltipCircle;
